export default __webpack_public_path__ + "static/media/Setting_fill.b6329f86.svg";